import { Typography } from "@mui/material";
import Paper from "@components/Paper/Paper";
import PaperItem from "@components/Paper/PaperItem";
import { useOutletContext } from "react-router-dom";
import ParcelsTable from "../components/table/ParcelsTable";
import { mapPaqDetails, type PaqItem } from "../mappers/paqDetailsMapper";
import {
  TEST_ID_BASE,
  type VesselNominationDetailsOutletContext,
} from "../VesselNominationDetails";

const transStyleClass = "font-normal text-[#646A77]";
const wrapperBaseStyleClass = "pb-3 flex gap-4";
const wrapperBorderStyleClass = "border-b border-[#F1F2F4]";
const wrapperStyleClass = `${wrapperBorderStyleClass} ${wrapperBaseStyleClass}`;
const wrapperLastStyleClass = wrapperBaseStyleClass;
const colStartStyleClass: Record<NonNullable<PaqItem["colStart"]>, string> = {
  1: "md:col-start-1 ",
  2: "md:col-start-2 ",
};

const getWrapperStyle = (
  index: number,
  itemsLength: number,
  rowSpan?: PaqItem["rowSpan"],
  colStart?: PaqItem["colStart"],
) => {
  const rowSpanClass = rowSpan === 2 ? "md:row-span-2 " : "";
  const colStartClass = colStart ? colStartStyleClass[colStart] : "";

  if (index === itemsLength - 1) {
    return `${rowSpanClass}${colStartClass}${wrapperLastStyleClass}`;
  }

  if (index === itemsLength - 2) {
    return `${rowSpanClass}${colStartClass}${wrapperStyleClass} md:border-b-0`;
  }

  return `${rowSpanClass}${colStartClass}${wrapperStyleClass}`;
};

const PAQ = () => {
  const { nominationDetails } = useOutletContext<VesselNominationDetailsOutletContext>();
  const paqData = mapPaqDetails(nominationDetails);

  return (
    <div data-testid={`${TEST_ID_BASE}-paq`} className="mt-8 grid grid-cols-1 gap-8">
      {paqData.map((section) =>
        section.isTable ? (
          <div key={section.testId} data-testid={section.testId}>
            <Typography variant="body2" sx={{ marginBottom: 3 }}>
              {section.title}
            </Typography>
            <ParcelsTable rows={section.items[0].tableValues} />
          </div>
        ) : (
          <Paper key={section.testId} variant="outlined" sx={{ height: "100%" }}>
            <div data-testid={section.testId}>
              <Typography variant="body2" sx={{ marginBottom: 3 }}>
                {section.title}
              </Typography>
              <div className="grid w-full grid-cols-1 md:grid-cols-2">
                {section.items.map((item, index) => (
                  <PaperItem
                    key={item.testId}
                    testId={item.testId}
                    translate={item.label}
                    textStyles="font-normal"
                    tranStyle={transStyleClass}
                    wrapperStyle={getWrapperStyle(
                      index,
                      section.items.length,
                      item.rowSpan,
                      item.colStart,
                    )}
                    text={item.unitOfMeasure ? `${item.value} ${item.unitOfMeasure}` : item.value}
                  />
                ))}
              </div>
            </div>
          </Paper>
        ),
      )}
    </div>
  );
};

export default PAQ;
